import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Config } from '../../config/config';
import { QuyTrinhThoiGian } from './quy-trinh-thoi-gian';
@Injectable()
export class QuyTrinhThoiGianService {

    controller: string = 'HT_QuyTrinhThoiGian';
    constructor(private http: Http) { }

    GetList(idQuyTrinh: number, idLoai: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller + "/GetList?idQuyTrinh=" + idQuyTrinh + "&idLoai=" + idLoai, { headers: headers }).map(resp => resp.json());
    }
    Save(idQuyTrinh: number, listQuyTrinhThoiGian: any[]) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        let options = new RequestOptions({ headers: headers });

        return this.http.post(Config.apiUrl + this.controller + '/save?idQuyTrinh=' + idQuyTrinh,
            JSON.stringify(listQuyTrinhThoiGian),
            options
        ).map(resp => resp.json())
    }

}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/quy-trinh-thoi-gian.service.ts